import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="bg-gradient-to-br from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-10">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-white mb-3">{appData.title}</h2>
            <p className="text-sm text-white/80 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              {appData.desc}
            </p>
            <div className="flex flex-wrap gap-3 justify-center lg:justify-start mb-6">
              {appData.features.map((feature) => (
                <span
                  key={feature}
                  className="flex items-center gap-1.5 px-3 py-1.5 bg-white/15 text-white text-xs rounded-lg whitespace-nowrap"
                >
                  <i className="ri-check-line"></i>
                  {feature}
                </span>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 bg-white text-primary-600 rounded-lg text-sm font-medium hover:bg-white/90 transition-colors duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-apple-fill mr-1.5"></i>
                iOS 版下载
              </a>
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 bg-white/15 text-white border border-white/30 rounded-lg text-sm font-medium hover:bg-white/25 transition-colors duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-android-fill mr-1.5"></i>
                Android 版下载
              </a>
            </div>
          </div>

          <div className="lg:w-[300px] shrink-0 flex justify-center">
            <div className="w-48 h-80 bg-white/10 rounded-2xl border border-white/20 flex items-center justify-center">
              <div className="text-center text-white/60">
                <i className="ri-smartphone-line text-4xl mb-2 block"></i>
                <span className="text-xs">扫码下载</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}